import {
  all, call, put, select, takeEvery,
} from 'redux-saga/effects';
import { IAppRequest } from 'src/typings/app';
import { ActionTypes } from 'src/store/requests/app/actions';
import { getComplexId } from 'src/store/app/selectors';
import {
  getPanoramaByEntity, getPanoramaByEntityBatch, getSpinnerByEntity, getSpinnerByEntityBatch,
} from 'src/api';
import { HydraResponse } from 'src/api/hydraResponse';
import { Actions as ActionsPano } from './actions';
import { ISpinnerWrapper } from '../spinner/reducer';
import { IPanoramaWrapper } from './reducer';

export function* setPanoramaDataParams(action: {
  type: string,
  payload: IAppRequest,
}) {
  const complexId: number | null = yield select(getComplexId);
  if (action.payload && complexId) {
    const {
      entity_inner_data_relation,
    } = action.payload;

    const panoramas: any = {};

    // @ts-ignore
    const responsesComp: any = yield call(async () => {
      const res = await Promise.all([
        getPanoramaByEntity(complexId, 'complex'),
        getSpinnerByEntity(complexId, 'complex'),
      ]);
      return res.flatMap((views) => views.data['hydra:member']).sort((a, b) => a.sequence - b.sequence);
    });
    if (responsesComp.length) {
      if (!panoramas.complex) {
        panoramas.complex = {};
      }
      panoramas.complex[complexId] = responsesComp;
    }

    if (entity_inner_data_relation.house) {
      const houseIds = Object.keys(entity_inner_data_relation.house);
      const responses: HydraResponse<IPanoramaWrapper[] | ISpinnerWrapper[]>[] = yield all([
        getPanoramaByEntityBatch(houseIds, 'house'),
        getSpinnerByEntityBatch(houseIds, 'house'),
      ]);
      const allViews: ISpinnerWrapper[] | IPanoramaWrapper[] = responses.flatMap((views) => views.data['hydra:member']);

      if (responses.length) {
        houseIds.forEach((houseId) => {
          const findedViews = allViews.filter((view: ISpinnerWrapper | IPanoramaWrapper) => view.house === `/api/houses/${houseId}`);
          if (findedViews.length) {
            if (!panoramas.house) {
              panoramas.house = {};
            }
            panoramas.house[houseId] = findedViews;
          }
        });
      }
    }

    if (Object.keys(panoramas).length) {
      yield put(ActionsPano.setAvailablePanoramas(panoramas));

      const entityName = Object.keys(panoramas)[0];
      yield put(ActionsPano.setCurrentPanorama(
        {
          entity: entityName,
          entityId: Object.keys(panoramas[entityName])[0],
          id: panoramas[entityName][Object.keys(panoramas[entityName])[0]][0].id,
        },
      ));
    }
  }
}

export function* getPanoramaWatchSaga() {
  yield takeEvery(ActionTypes.GET_APP_DATA_REQUEST_SUCCESS, setPanoramaDataParams);
}
